import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60_000,
      gcTime: Infinity,
      throwOnError: true,
    },
  },
});

export default queryClient;
